<template>
  <div>
    <div class="main-content">
      <div id="boxloading"></div>
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">メインメニュー</a>
            </li>
            <router-link tag="li" :to="{ name: 'gates'}">
              <a>ゲート一覧</a>
            </router-link>
            <li class="active">CSVファイルのインポート</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>CSVファイルのインポート</h3>
          </div>
        </div><!-- /.page-header -->
        <div class="page-content register_user">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="tab-content">
            <div class="row">
              <div class="col-xs-12">
                <!-- PAGE CONTENT BEGINS -->
                <div class="alert alert-info">
                  ゲートの編集をCSVファイルから行うことができます。<br>
                  アップロードするCSVファイルを選択し、「ファイルをインポート」してください。
                </div>
                <div>
                  <div class="fallback">
                    <p class="desc">自分のコンピューターからファイルを選択する ：</p>
                    <label for="file_csv" class="btn-upload">
                      CSVファイルを選択
                      <input type="file" id="file_csv" style="display:none;" ref="myFiles" class="custom-file-input" @change="previewFiles" multiple accept='.csv'>
                    </label>
                    <span class="filename">選択されていません</span>
                    <div class="alert alert-danger" id="error-alert">
                      <div v-html="message"></div>
                    </div>
                    <div class="alert alert-success" id="success-alert">
                      <div v-html="message"></div>
                    </div>
                    <span class="error"></span>
                    <div id="result">
                    </div>
                    <button class="btn btn-info" type="button" @click="importExe()" href="#process" data-toggle="modal">
                      ファイルをインポート
                    </button>
                  </div>
                </div>
              </div><!-- /.col -->
            </div><!-- /.row -->
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
    <!-- プロフィールModal -->
    <div id="process" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <span class="progress-question">CSVファイルのインポート</span>
            <div class="progress" v-bind:class="{'progress-striped':!success , active:!success}" v-if="message.length === 0">
              <div class="progress-bar" :style="progressWidth">
              <span>{{ Math.round(progress) }}%</span>
              </div>
            </div>
            <div v-else style="width:100%;padding:10px;border:1px solid #ccc;color:red;margin-top:10px">
              <div v-html="message"></div>
            </div>
            <span class="success-label" v-if="successItem>0">{{totalDataRow}}件中{{successItem}}件をインポートしました。</span>
            <div v-if="errorMessage.length>0">
              <span class="error-box-title">インポート失敗</span>
              <div class="error-box">
                <template v-for="item in errorMessage">
                  <p v-html="item" :key="item"></p>
                </template>
              </div>
            </div>
          </div>
          <div class="modal-footer">
          <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success" @click="reset()">OK</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
import * as Config from '../../config'

export default {
  data () {
    return {
      files: null,
      errorMessage: [],
      loading: false,
      message: '',
      errorName: '',
      progress: 0,
      success: false,
      importData: [],
      totalDataRow: 0,
      successItem: 0,
      exeCount: 0,
      percent: 0
    }
  },
  // totalDataRowとはCSVファイルの中にある項目数。
  // exeCountとはAPI実行回数、デフォルトの値は０です。
  // 一回APIを実行が終わるとexeCount に１をプラスする。
  // 全部APIを実行が終わるとexeCount の値は０にリセットする。
  // exeCount<totalDataRowの時は次のAPI実行。
  // exeCount===totalDataRowの時(全部APIを実行が終わったの時)は変数の値リセットする。
  watch: {
    exeCount: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.totalDataRow) {
        if (vm.importData[newVal][0].length > 0) {
          vm.editExe(vm.importData[newVal][0], vm.importData[newVal][1], vm.importData[newVal][2], vm.importData[newVal][3], vm.importData[newVal][4], vm.importData[newVal][5], vm.importData[newVal][6], vm.importData[newVal][7], vm.importData[newVal][8], vm.importData[newVal][9], vm.importData[newVal][10], vm.importData[newVal][11], vm.importData[newVal][12], vm.importData[newVal][13], vm.importData[newVal][14], vm.importData[newVal][15], vm.importData[newVal][16], vm.importData[newVal][17], vm.importData[newVal][18], vm.importData[newVal][19], vm.importData[newVal][20], vm.importData[newVal][21], vm.importData[newVal][33], (newVal + 2), vm.percent)
        } else {
          vm.addExe(vm.importData[newVal][1], vm.importData[newVal][2], vm.importData[newVal][3], vm.importData[newVal][4], vm.importData[newVal][5], vm.importData[newVal][6], vm.importData[newVal][7], vm.importData[newVal][8], vm.importData[newVal][9], vm.importData[newVal][10], vm.importData[newVal][11], vm.importData[newVal][12], vm.importData[newVal][13], vm.importData[newVal][14], vm.importData[newVal][15], vm.importData[newVal][16], vm.importData[newVal][17], vm.importData[newVal][18], vm.importData[newVal][19], vm.importData[newVal][20], vm.importData[newVal][21], vm.importData[newVal][33], (newVal + 2), vm.percent)
        }
      } else if (newVal > 0 && newVal === vm.totalDataRow) {
        this.exeCount = 0
        this.success = true
        this.importData = []
      }
    }
  },
  computed: {
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    }
  },
  methods: {
    reset () {
      this.exeCount = 0
      this.successItem = 0
      setTimeout(() => {
        this.success = false
      }, 200)
    },
    convertStringToBoolean (text) {
      var str = text.trim().toLowerCase()
      switch (str) {
        case '1':
          return true
        case '0':
          return false
        default:
          return true
      }
    },
    previewFiles () {
      this.files = this.$refs.myFiles.files[0]
      $('.filename').html(this.files.name)
    },
    editExe (gateId, gateName, gateModelId, gateModelName, gateModelCode, iconType, makerCode, customizable, target, controlTime, timeUnit, isVisitor, isNFCValid, isTenKeyValid, isGatePasswordValid, gatePasswordLength, gatePasswordSeed, isTwoStepAuthValid, bleIntensity, buzzerPattern, option1, option2, isValid, z, percent) {
      var vm = this
      const Infor = {
        gateName: gateName,
        gateModelId: gateModelId,
        gateModelName: gateModelName,
        gateModelCode: gateModelCode,
        iconType: 0,
        makerCode: parseInt(makerCode),
        customizable: vm.convertStringToBoolean(customizable),
        target: parseInt(target),
        controlTime: parseInt(controlTime),
        timeUnit: parseInt(timeUnit),
        isVisitor: false,
        isNFCValid: vm.convertStringToBoolean(isNFCValid),
        isTenKeyValid: vm.convertStringToBoolean(isTenKeyValid),
        isGatePasswordValid: vm.convertStringToBoolean(isGatePasswordValid),
        gatePasswordLength: parseInt(gatePasswordLength),
        gatePasswordSeed: gatePasswordSeed,
        isTwoStepAuthValid: vm.convertStringToBoolean(isTwoStepAuthValid),
        bleIntensity: parseInt(bleIntensity),
        buzzerPattern: parseInt(buzzerPattern),
        option1: option1,
        option2: option2,
        isValid: vm.convertStringToBoolean(isValid)
      }
      this.$http.put(Config.GATES_LIST_API + '/' + encodeURIComponent(encodeURIComponent(gateId)), Infor)
        .then(response => {
          console.log(response)
          vm.progress += percent
          vm.exeCount++
          vm.successItem++
        })
        .catch((error) => {
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                vm.errorName = ''
              } else {
                this.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              vm.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              vm.errorName = 'ゲートの編集権限がありません。'
              break
            case 404:
              vm.errorName = '該当するデーターがありません。'
              break
            case 409:
              vm.errorName = '入力されたゲート名は既に使用されています。他のゲート名を入力してください。'
              break
            case 500:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
          var rowstatus = z + ' 行目>>' + gateId + '>><span>' + vm.errorName + '</span>'
          this.$set(this.errorMessage, z, rowstatus)
          vm.progress += percent
          vm.exeCount++
          console.log(error)
        })
    },
    addExe (gateName, gateModelId, gateModelName, gateModelCode, iconType, makerCode, customizable, target, controlTime, timeUnit, isVisitor, isNFCValid, isTenKeyValid, isGatePasswordValid, gatePasswordLength, gatePasswordSeed, isTwoStepAuthValid, bleIntensity, buzzerPattern, option1, option2, isValid, z, percent) {
      var vm = this
      const Infor = {
        gateName: gateName,
        gateModelId: gateModelId,
        gateModelName: gateModelName,
        gateModelCode: gateModelCode,
        iconType: 0,
        makerCode: parseInt(makerCode),
        customizable: vm.convertStringToBoolean(customizable),
        target: parseInt(target),
        controlTime: parseInt(controlTime),
        timeUnit: parseInt(timeUnit),
        isVisitor: false,
        isNFCValid: vm.convertStringToBoolean(isNFCValid),
        isTenKeyValid: vm.convertStringToBoolean(isTenKeyValid),
        isGatePasswordValid: vm.convertStringToBoolean(isGatePasswordValid),
        gatePasswordLength: parseInt(gatePasswordLength),
        gatePasswordSeed: gatePasswordSeed,
        isTwoStepAuthValid: vm.convertStringToBoolean(isTwoStepAuthValid),
        bleIntensity: parseInt(bleIntensity),
        buzzerPattern: parseInt(buzzerPattern),
        option1: option1,
        option2: option2,
        isValid: vm.convertStringToBoolean(isValid)
      }
      console.log(Infor)
      this.$http.post(Config.GATES_LIST_API, Infor)
        .then(response => {
          vm.progress += percent
          vm.exeCount++
          vm.successItem++
          console.log(response)
        })
        .catch((error) => {
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                vm.errorName = ''
              } else {
                vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              vm.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              vm.errorName = 'ゲートの追加権限がありません。'
              break
            case 409:
              vm.errorName = '入力されたゲート名は既に使用されています。他のゲート名を入力してください。'
              break
            case 500:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
          var rowstatus = z + ' 行目>>' + gateName + '>><span>' + vm.errorName + '</span>'
          this.$set(this.errorMessage, z, rowstatus)
          vm.progress += percent
          vm.exeCount++
          console.log(error)
        })
    },
    importExe () {
      var vm = this
      this.progress = 0
      this.errorMessage = []
      if (this.files !== null) {
        var reader = new FileReader()
        reader.onload = function () {
          var lineArr = reader.result.split('\n')
          var itemArr = []
          for (var i = 0; i < lineArr.length; i++) {
            itemArr[i] = lineArr[i].split(',')
          }
          if (itemArr.length > 1) {
            for (var k = 1; k < itemArr.length; k++) {
              if (itemArr[k].length === 35 && itemArr[k][1].length > 0) {
                vm.importData.push(itemArr[k])
              }
            }
            if (vm.importData.length > 0) {
              vm.totalDataRow = vm.importData.length
              vm.message = ''
              vm.percent = (100 / (vm.totalDataRow))
              if (vm.importData[0][0].length > 0) {
                vm.editExe(vm.importData[0][0], vm.importData[0][1], vm.importData[0][2], vm.importData[0][3], vm.importData[0][4], vm.importData[0][5], vm.importData[0][6], vm.importData[0][7], vm.importData[0][8], vm.importData[0][9], vm.importData[0][10], vm.importData[0][11], vm.importData[0][12], vm.importData[0][13], vm.importData[0][14], vm.importData[0][15], vm.importData[0][16], vm.importData[0][17], vm.importData[0][18], vm.importData[0][19], vm.importData[0][20], vm.importData[0][21], vm.importData[0][33], (0 + 2), vm.percent)
              } else {
                vm.addExe(vm.importData[0][1], vm.importData[0][2], vm.importData[0][3], vm.importData[0][4], vm.importData[0][5], vm.importData[0][6], vm.importData[0][7], vm.importData[0][8], vm.importData[0][9], vm.importData[0][10], vm.importData[0][11], vm.importData[0][12], vm.importData[0][13], vm.importData[0][14], vm.importData[0][15], vm.importData[0][16], vm.importData[0][17], vm.importData[0][18], vm.importData[0][19], vm.importData[0][20], vm.importData[0][21], vm.importData[0][33], (0 + 2), vm.percent)
              }
            } else {
              vm.success = true
              vm.message = '不正なファイルです。正しいファイルを選択しなおしてください。'
            }
          } else {
            vm.success = true
            vm.message = '不正なファイルです。正しいファイルを選択しなおしてください。'
          }
        }
        reader.onerror = function () {
          vm.success = true
          vm.message = '選択されているファイルの読み込みに失敗しました。<br>ブラウザの更新、もしくは別ファイルを選択してから <br> 再度アップロードしたいファイルを選択してください。'
        }
        reader.readAsText(this.files, 'Shift_JIS')
      } else {
        vm.success = true
        vm.message = 'CSVのファイルを選択してください。'
      }
    }
  }
}
</script>
<style type="text/css">
#result p {
  margin-bottom: 0px
}
#result span {
  display: inline-block;
  padding: 5px;
}
#result span.error {
  color: red
}
#result span.success {
  color: #87B87F;
}
#result p.block {
  display: block;
  margin-bottom: 1px;
}
.btn-upload{
  color: white;
  background-color: #000;
  padding: 6px 15px;
  border-radius: 12px;
  cursor: pointer;
  display: inline-block;
  margin: 0px 15px
}
.desc{
  display: inline-block;
  font-size: 15px;
  font-weight: bold;
}
.filename{
  display: inline-block;
}
.hide{
  display: none;
}
.error{
  display: block;
  color: #FF4040
}
</style>



// WEBPACK FOOTER //
// src/views/gate/GateImport.vue